import React from "react";

import Svg from "../../assets/images/icons/Form Controls/Link.svg";

export const LinkIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={Svg}
        alt={alt || "Link"}
    />
);
